import React, { useState, useEffect } from 'react'
import './Article.css'
import { Link } from 'react-router-dom'

import Facebook from '../assets/logos_facebook.svg'
import Twitter from '../assets/fa6-brands_square-x-twitter.svg'
import Linkedin from '../assets/skill-icons_linkedin.svg'
import Link1 from '../assets/Link.svg'
import A1 from '../assets/A1.webp'
import A2 from '../assets/A2.webp'

import Post1 from '../assets/Post1.webp'
import Post2 from '../assets/Post2.webp'

import Post3 from '../assets/Post3.webp'
import { motion as m } from "framer-motion";
import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'

const Article2 = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    return (
        <m.div
            className="Article"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            {/* <TopBar /> */}
            <div className="Article-page">
                <div className="Article-main">
                    <div className="Article-header">
                        <div className="Article-header-top">
                            <div className="Article-header-top-breadcrumb">
                            <Link to="/news"> <div className="Article-header-top-breadcrumb-text1">{t('NewsP1')}</div></Link>
                               {/* <div className="Article-header-top-breadcrumb-text2">5 key generative AI use cases in insurance distribution</div>*/}
                            </div>
                            {deviceWidth > 768 &&
                                <div className="Article-header-top-date">Mar 6,2024</div>}
                        </div>
                        {/*<div className="Article-info">
                            <p className="Article-info-title">5 key generative AI use cases in insurance distribution</p>
                            {deviceWidth >= 768 &&
                                (<div className="Article-author-top-right">
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Facebook} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Twitter} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Linkedin} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Link1} className="Article-author-top-right-social-icon" />
                                    </div>
                                </div>
                                )}
                            </div>*/}

                    </div>

                    <img loading="lazy" decoding="async" alt="" src={Post2} className="Article-main-image" />

                    <div className="Article-main-text">
                    On March 5th, Khamsa Insurance and Reinsurance Brokers LLC, with the support of the Azerbaijan Banks Association and the British Chamber of Commerce Azerbaijan (BCCA), hosted a seminar titled "Secure the Boundaries" focusing on "Cyber Insurance and Directors and Officers (D&O) Insurance." 
                    <br/>
                    Distinguished speakers from the insurance sector brought their expertise to the table, offering attendees invaluable insights and practical advice on managing cyber risks and protecting corporate leadership. Topics ranged from the latest developments in cyber threats to regulatory compliance and strategies for mitigating risks associated with directors and officers.
                    <br/>
                    The seminar provided a platform for interactive discussions, enabling attendees to engage with industry professionals, ask questions, and expand their networks. By learning from experts in the field, participants gained a deeper understanding of cyber insurance and D&O insurance, empowering them to safeguard their organizations amidst the complexities of the digital landscape.
                    <br/>
                    <br/>
                    Dear Simon Aubrey Jones, Paolo Ferrarese and Ashley Cliff, 
On behalf of the entire team at Khamsa Insurance and Reinsurance Brokers, we wanted to extend our sincerest gratitude for your invaluable contributions to our seminar!
                      </div>

                </div>

                <div className="Article-rec">
                    <p className="Article-rec-header">{t("NewsP3")}</p>
                    <div className="Article-rec-bottom">

                    <Link to='/article1'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post1} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                    {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    Sharing with you some photos from our latest seminar! It was a wonderful day filled with knowledge exchange and valuable connections. Thanks to everyone who
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Mar 30,2024</p>

                            </div>
                        </div></Link>

                        <Link to='/article2'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post2} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                    {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    On March 5th, Khamsa Insurance and Reinsurance Brokers LLC, with the support of the Azerbaijan Banks Association and the British Chamber of Commerce Azerbaijan (BCCA), hosted a seminar titled "Secure the Boundaries" focusing on "Cyber Insurance and Directors and Officers (D&O) Insurance."
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Mar 6,2024</p>

                            </div>
                        </div></Link>


                        <Link to='/article3'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post3} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                     {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    Dear Partners,
On 29 January, Khamsa Insurance and Reinsurance Brokers held an important event on "Safe Steps to Foundation in Post-Conflict Areas" at the initiative of the Central Bank of the Republic of Azerbaijan and with support of the Azerbaijan Insurers
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Jan 30,2024</p>

                            </div>
                        </div></Link>



                        {deviceWidth <= 1023 && deviceWidth >= 768 && (

<Link to='/article1'>
<div className="Article-rec-element">

    <img loading="lazy" decoding="async" alt="" src={A2} className="Article-rec-element-img" />
    <div className="Article-rec-element-info">
        <div className="Article-rec-element-info-top">
             {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
            <div className="Article-rec-element-info-top-header-text">
                With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </div>
        </div>
        <p className="Article-rec-element-info-bottom-frame-time">Aug 19, 2024</p>

    </div>
</div></Link>


                        )
                        }
                    </div>
                </div>
            </div>
            <Footer />
        </m.div>
    )
}

export default Article2